import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGCAL extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAG CAL</h1>
        </header>

        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.2346 (E) Dated 26-05-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (5) Mixture of Humic acid and Seaweed extract (Liquid)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Humic acid (Source: Leonardite) percent weight by volume, minimum: 6</li>
                <li>(ii) Kappaphycus alvarezii and Sargassum swartzii in ratio of 1:1; liquid concentrate percent volume by volume, minimum: 4</li>
                <li>(iii) Propyl paraben percent weight by volume, minimum as preservative: 0.02</li>
                <li>(iv) Methyl paraben percent weight by volume, minimum as preservative: 0.2</li>
                <li>(v) Potassium benzoate percent weight by volume, minimum: 0.1</li>
                <li>(vi) Water percent by weight: 89.68</li>
                <li>(vii) Total (percent): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Tomato</li>
            <li><span className="label">5. Doses:</span> Tomato: Three foliar applications at 1.25 l/ha</li>
          </ul>
        </div>

        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.2292 (ई) दिनांक 26-05-2025</li>
            <li><span className="label">2. जैव उत्तेजक का नाम:</span> (5) ह्यूमिक अम्ल और समुद्री शैवाल अर्क का मिश्रण (तरल)</li>
            <li><span className="label">3. संघटन:</span>
              <ul>
                <li>(i) ह्यूमिक अम्ल (स्रोत: लियोनार्डाइट) प्रतिशत भार (आयतन द्वारा), न्यूनतम: 6</li>
                <li>(ii) कप्पाफाइकस साल्वारेज़ि और सारगासम स्वार्ट्ज़ि अनुपात 1:1; द्रव सांद्रण प्रतिशत आयतन दर आयतन, न्यूनतम: 4</li>
                <li>(iii) प्रोपाइल पैराबेन प्रतिशत, भार दर आयतन, न्यूनतम परिरक्षक: 0.02</li>
                <li>(iv) मिथाइल पैराबेन प्रतिशत, भार दर आयतन, न्यूनतम परिरक्षक: 0.2</li>
                <li>(v) पोटेशियम बेंजोएट प्रतिशत, भार दर आयतन, न्यूनतम: 0.1</li>
                <li>(vi) जल प्रतिशत, भार दर: 89.68</li>
                <li>(vii) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> टमाटर</li>
            <li><span className="label">5. मात्रा:</span> टमाटर: 1.25 लीटर/हेक्टेयर की दर से तीन पर्णीय छिड़काव</li>
          </ul>
        </div>

        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> S.O.2292 (E) दिनांक २६-०५-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (५) ह्युमिक अॅसिड आणि सीव्हीड अर्क (द्रव) यांचे मिश्रण</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) ह्युमिक अॅसिड (स्रोत: लिओनार्डाइट) प्रमाणानुसार वजनाचे टक्के, किमान: ६</li>
                <li>(ii) कप्पाफायकस सॅल्व्हेरेझिया आणि सार्गासम स्वर्ट्झिया १:१ चे प्रमाण; द्रव सांद्रता प्रति टक्के आकारमानानुसार, किमान: ४</li>
                <li>(iii) प्रोपिल पॅराबेन टक्के वजनानुसार, किमान संरक्षक: ०.०२</li>
                <li>(iv) मिथाइल पॅराबेन टक्के वजनानुसार, किमान संरक्षक: ०.२</li>
                <li>(v) पोटॅशियम बेंझोएट टक्के वजनानुसार, किमान: ०.१</li>
                <li>(vi) पाणी टक्के वजनानुसार: ८९.६८</li>
                <li>(vii) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> टोमॅटो</li>
            <li><span className="label">५. मात्रा:</span> टोमॅटो: १.२५ लिटर/हेक्टर दराने तीन पानांवरील वापर</li>
          </ul>
        </div>

      </div>
    )
  }
}
